import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const AccountsInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Accounts Section"
    sectionKey="Accounts"
    backRoute="/sections/accounts"
  />
);

export default AccountsInternalTransfer;
